// REUSABLE COMPONENTS
// ===================================================

var components = {

    settings: {
        accordions: $('.component-accordion'),
        ajax_profile_modal: $('.component-ajax-profile-modal'),
        tab_bars: $('.component-tab-bar'),
        vimeo_modals: $('.component-vimeo-modal'),
    },

    init: function() {
        // Accordions
        if (this.settings.accordions.length) {
            this.accordions();
        }
        // AJAX Profile Modal
        if (this.settings.ajax_profile_modal.length) {
            this.ajaxProfileModal();
        }
        // Tab Bars
        if (this.settings.tab_bars.length) {
            this.tabBars();
        }
        // Vimeo Modals
        if (this.settings.vimeo_modals.length) {
            this.vimeoModals();
        }
    },

    // Accordions
    accordions: function() {

        components.settings.accordions.find('.js-toggle-accordion').on('click keydown', function(e) {
            if (global_helpers.accessibilityButtons(e)) {
                $(this).closest('.component-accordion').toggleClass('open');
                $(this).closest('.component-accordion').find('.content').slideToggle(250);
            }
        });

    },

    // AJAX Profile Modal
    ajaxProfileModal: function() {

        // Open profile modal on block interaction (NOTE: will need to be AJAX later when people CPT is in place
        $('[data-profile-modal-id]:not(.profileLink--none)').on('click keydown', function(e) {

            if (global_helpers.accessibilityButtons(e)) {

                var profile_id = $(this).data('profile-modal-id');
                var modal = $(this).closest('section').find('.component-ajax-profile-modal');
                var close = modal.find('.js-close-profile-modal');

                // Populate profile data
                getProfileData(modal, profile_id);

                // Close button
                close.on('click keydown', function(e) {
                    if (global_helpers.accessibilityButtons(e)) {
                        modal.removeClass('active');
                        $('body').removeClass('no-scroll');
                    }
                });

                // Close modal by clicking the overlay
                modal.on('click', function(e) {
                    e.stopPropagation();
                    if (e.target == this) {
                        modal.removeClass('active');
                        $('body').removeClass('no-scroll');
                    }
                });

            }

        });

        // Retrieve profile data and populate modal
        function getProfileData(modal, profile_id) {

            if (captrust_theme_url) {

                $.ajax({
                    url: captrust_theme_url + '/template-parts/ajax/ajax-profile-modal-get-data.php',
                    type: 'POST',
                    data: {
                        id: profile_id,
                    },
                    success: function(data) {
                        modal.find('.ajax-profile-data').html(data);
                        modal.addClass('active');
                        modal.trigger('profileModalActive');
                        $('body').addClass('no-scroll');
                    },
                });

            }
        }

    },


    // Tab Bars : Clicking tabs/selecting dropdowns to show/hide content
    tabBars: function() {

        // Tabs
        var tabs = components.settings.tab_bars.find('[data-tab-bar-target]');

        tabs.on('click keydown', function(e) {
            if (global_helpers.accessibilityButtons(e)) {
                // Deactivate tabs in the same group
                $(this).siblings().removeClass('active');
                // Activate selected tab
                $(this).addClass('active');
                // Find the target item
                var target = $(this).closest('section').find('[data-tab-bar-item="' + $(this).data('tab-bar-target') + '"]');
                // Deactivate target items in the same group
                target.siblings().removeClass('active');
                // Activate the target item
                target.addClass('active');
            }
        });

        // Tabs as Dropdowns
        var dropdowns = components.settings.tab_bars.find('.tabs-dropdown select');

        dropdowns.on('change', function() {

            // Selected Option
            var selected = $(this).find(':selected');

            // Standard Tabs
            if (selected.data('tab-bar-target')) {
                // Find the target item
                var target = $(this).closest('section').find('[data-tab-bar-item="' + $(this).find(':selected').data('tab-bar-target') + '"]');
                // Deactivate target items in the same group
                target.siblings().removeClass('active');
                // Activate the target item
                target.addClass('active');
            }

            // Tabs as Links
            if (selected.data('tab-bar-link')) {
                window.location.href = selected.data('tab-bar-link');
            }

        });
    },

    // Vimeo Modals
    vimeoModals: function() {

        $('[data-vimeo-modal-target]').each(function() {

            var target_id = $(this).data('vimeo-modal-target').toString();
            
            // Account for forward slashes in video IDs
            target_id = target_id.replace('/', '\\/');

            var modal = $(this).closest('section').find('[data-vimeo-modal=' + target_id + ']');
            var iframe = modal.find('iframe');
            var close = modal.find('.js-close-vimeo-modal');
            var expand_transcript = modal.find('.js-expand-transcript');
            var transcript_container = modal.find('.transcript-container')
            var player;

            // Open modal
            $(this).on('click keydown', function(e) {
                if (global_helpers.accessibilityButtons(e)) {
                    player = new Vimeo.Player(iframe);
                    modal.addClass('active');
                    $('body').addClass('no-scroll');
                }
            });

            // Close button
            close.on('click keydown', function(e) {
                if (global_helpers.accessibilityButtons(e)) {
                    $('body').removeClass('no-scroll');
                    modal.removeClass('active');
                    expand_transcript.removeClass('open');
                    transcript_container.slideUp(500);
                    player.pause();
                }
            });
            
            // Close modal by clicking the overlay
            modal.on('click', function(e) {
                e.stopPropagation();
                if (e.target == this) {
                    $('body').removeClass('no-scroll');
                    modal.removeClass('active');
                    expand_transcript.removeClass('open');
                    transcript_container.slideUp(500);
                    player.pause();
                }
            });
            
            // Expand transcript
            expand_transcript.on('click keydown', function(e) {
                if (global_helpers.accessibilityButtons(e)) {
                    if ($(this).hasClass('open')) {
                        $(this).removeClass('open');
                        transcript_container.slideUp(500);
                    } else {
                        $(this).addClass('open');
                        transcript_container.slideDown(500);
                    }
                }
            });

        });

    },

};
components.init();